import axios from "axios";

/**
 * Post a blob to a presigned (S3) upload URL
 */
export async function postFileToPresignedUrl(
  video: Blob,
  signedUploadUrl: { url: string; fields: any },
  onProgress: (bytesDone: number, bytesTotal: number) => void
): Promise<void> {
  const fd = new FormData();
  for (const field in signedUploadUrl.fields) {
    fd.append(field, signedUploadUrl.fields[field]);
  }
  fd.append("acl", "public-read");
  fd.append("file", video);

  onProgress(0, video.size);

  await axios.post(signedUploadUrl.url, fd, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    },
    onUploadProgress: (progressEvent) => {
      onProgress(progressEvent.loaded, video.size);
    },
  });
}
